export default __webpack_public_path__ + "static/media/dropdown.fb9d0524.svg";